<template>
    <div class="devices-list__block scenario-group" v-if="scenarioGroup" :class="!showLocation && !edit ? 'scenario-group__low' : ''">
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <template v-slot:actions>
                        <v-icon class="icon-expand">$expand</v-icon>
                    </template>
                    <div class="group-header">
                        <scenario-group-status v-if="showLocation || edit" :group="scenarioGroup" :edit="edit" :show-location="showLocation"/>
                        <div class="group-header__content">
                            <v-layout row class="devices-list__block__title">
                                <v-flex class="title-block">
                                    <div class="title-block__name">
                                        {{ scenarioGroup.name }}
                                    </div>
                                </v-flex>
                                <v-flex class="btn-block">
                                    <div class="d-inline-flex">
                                        <v-switch
                                            v-model="scenarioGroup.enabled"
                                            inset
                                            dense
                                            hide-details
                                            class="pa-0"
                                            color="#FF8484"
                                            :loading="loading"
                                            :disabled="scenarioGroup.disabled"
                                            @click.stop.prevent="changeGroupState"
                                        ></v-switch>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </div>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div v-for="(scenario, index) in scenarioGroup.scenarios" :key="'scenarioGroup' + index">
                        <ScenarioSwitch :scenario="scenario" :available="available" group showLocation/>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import ScenarioSwitch from "@/components/rooms/ScenarioSwitch";
import { LOADING_TIMEOUT } from "@/utils/constants.js";

export default {
    name: "ScenarioGroup",
    components: {ScenarioSwitch},
    props: {
        group: {
            type: Object,
            required: true,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
        available: {
            type: Object,
            default: () => {},
        },
        edit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            scenarioGroup: [],
            loading: false,
        };
    },
    created() {
        this.scenarioGroup = JSON.parse(JSON.stringify(this.group));
    },
    watch: {
        group(val) {
            if (val) {
                this.scenarioGroup = JSON.parse(JSON.stringify(val));
                this.loading = false;
            }
        },
    },
    methods: {
        changeGroupState() {
            if (this.scenarioGroup.scenarios.length > 0) {
                this.loading = true;
                this.scenarioGroup.disabled = true;
                this.$http.put('/scenarios/hotel-admin/scenario-group/' + this.scenarioGroup.scenarios[0].uid + '/', this.scenarioGroup)
                    .catch((error) => {
                        this.scenarioGroup.enabled = !this.scenarioGroup.enabled;
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                        this.scenarioGroup.disabled = false;
                    });
            }
        },
    },
}
</script>
